import { alpha, filledInputClasses } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4.5),
  },

  inputContainer: {
    display: 'flex',
    position: 'relative',
    '&&&&': {
      pointerEvents: 'none',
      cursor: 'default',
    },
  },

  receiveRoot: {
    alignItems: 'flex-end',

    '&&&&': {
      pointerEvents: 'none',
      cursor: 'default',
    },

    [`&&:focus, &&.${filledInputClasses.focused}`]: {
      boxShadow: `0 0 0 2px ${alpha(theme.palette.text.primary, 0.15)}`,
    },
  },

  receiveInput: {
    pointerEvents: 'none',
    paddingTop: theme.spacing(10),
    paddingLeft: theme.spacing(2),

    '&&&&': {
      pointerEvents: 'none',
      cursor: 'default',
    },
  },

  label: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },

  tokenIcon: {
    marginBottom: theme.spacing(4.5),
    width: 32,
    height: 32,
  },

  errorText: {
    color: theme.palette.error.main,
  },

  button: {
    position: 'absolute',
    width: 40,
    height: 40,
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${alpha(theme.palette.divider, 0.1)}`,
    borderRadius: theme.spacing(4),
    left: 'calc(50% - 20px)',
    top: -30,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  arrow: {
    transform: 'rotate(-90deg)',
  },
}));
